<template>
  <tr>
    <th class="font-weight-regular text-right">{{caption}}</th>
    <td class="pl-2 font-weight-bold text--primary">
      <slot/>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'CPanelContent',
  props: {
    caption: {
      type: String,
      required: true
    }
  }
}
</script>
